import type { FC, ReactElement } from "react";
import { type BaseFieldProps, Field, type WrappedFieldProps } from "redux-form";

import CheckboxSelect from "../forms/CheckboxSelect.js";
import { FormInputGroup } from "@/ui-modules/core/form/layout/FormGroup.js";
import { FormInputWidget } from "@/ui-modules/core/form/layout/FormInputWidget.js";
import { FormLabel } from "@/ui-modules/core/form/layout/FormLabel.js";
import type { IOptionObject } from "@/ui-modules/core/forms/CheckboxMultiSelect/Option.js";

type CheckboxSelectOptionType = any;

// // TODO should extend also from ICheckboxSelectProps ?
export interface ICheckboxSelectFieldProps extends Partial<WrappedFieldProps> {
  // input?: any; // injected as WrappedFieldProps
  // meta?: any; // injected as WrappedFieldProps

  placeholder?: string;
  uniqueKey?: string;
  title?: string | ReactElement;
  options?: CheckboxSelectOptionType[];
  labelKey?: string;
  valueKey?: string;
  showFilter?: boolean;
  showSelectAll?: boolean;
  allSelectedPlaceholder?: string;
  manySelectedPlaceholder?: string;
  tooltip?: string;
  renderItemLabel?: boolean;
  numberDisplayed?: number;

  handleChange?: (e: IOptionObject[]) => void;
  horizontalLayout?: boolean;
}

/**
 * Checkbox Select field to be used in context of redux-form
 */
const CheckboxSelectField: FC<ICheckboxSelectFieldProps> = (field) => {
  return (
    <FormInputGroup>
      {field.title && <FormLabel>{field.title}</FormLabel>}
      <FormInputWidget>
        <CheckboxSelect
          uniqueKey={field.uniqueKey}
          showFilter={field.showFilter}
          showSelectAll={field.showSelectAll}
          value={field.input.value}
          options={field.options}
          placeholder={field.placeholder}
          numberDisplayed={field.numberDisplayed !== null ? field.numberDisplayed : 1}
          valueKey={field.valueKey}
          labelKey={field.labelKey}
          onChange={(e) => {
            field.input.onChange(e);
            field.handleChange?.(e);
          }}
          allSelectedPlaceholder={field.allSelectedPlaceholder}
          manySelectedPlaceholder={field.manySelectedPlaceholder}
          defaultFocusFilter={true}
          renderItemLabel={field.renderItemLabel}
        />
      </FormInputWidget>
    </FormInputGroup>
  );
};

export default CheckboxSelectField;

export function CheckboxSelectReduxFormField(props: ICheckboxSelectFieldProps & BaseFieldProps) {
  return <Field {...props} />;
}
